module.exports = __webpack_public_path__ + "img/rhtj_top.f4d47b6c.png";